<template>
  <el-card id="devops-settings">
    <div slot="header">
      <el-button
        size="mini"
        icon="mdi mdi-console"
        :disabled="!config.sshd"
        @click="console = true"
      >
        Console SSH
      </el-button>
      DevOps settings
    </div>

    <el-collapse accordion>
      <ConfigSshd
        :config.sync="config"
        :public-ip="instance.publicIp"
        :username="application.name"
        :port="application.port"
        @change="save"
      />

      <ConfigSmtpd :config.sync="config" @change="save" />

      <ConfigHttpd
        v-if="bundle.httpd"
        :config.sync="config"
        @change="save"
      />
    </el-collapse>

    <Console v-if="console" :open.sync="console" :application-id="application.id" />
  </el-card>
</template>

<script>
import Console from './Console'
import ConfigSshd from './Config/Sshd'
import ConfigSmtpd from './Config/Smtpd'
import ConfigHttpd from './Config/Httpd'

export default {
  props: {
    instance: {
      type: Object,
      default: () => ({})
    },
    application: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Console,
    ConfigSshd,
    ConfigSmtpd,
    ConfigHttpd
  },
  data () {
    return {
      console: false,
      config: { ...this.application.devops || {} }
    }
  },
  computed: {
    bundle () {
      return this.$root.bundles[this.application.bundleId]
    }
  },
  methods: {
    save () {
      this.$store.dispatch('devopsApplication', {
        ...this.application,
        devops: this.config
      })
    }
  },
  watch: {
    'application.devops' (value) {
      this.config = { ...value || {} }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../theme";

  #devops-settings {
    position: relative;

    .el-card__header {
      color: #ff4949;
      font-weight: 500;

      .el-button {
        float: right;
        margin-top: -5px;
      }
    }

    .el-collapse {
      margin: -13px -12px 12px;

      p small {
        font-size: 85%;
        display: block;
      }

      .el-switch {
        display: block;
      }

      .el-collapse-item > div > div {
        padding-left: 12px;
        padding-right: 10px;

        .el-tag {
          position: absolute;
          right: 46px;
        }
      }
    }
  }
</style>
